<template>
    <div style="background-color: white;">
        <div style="display: flex; flex-direction: column; padding: 10px 20px;">
            <div style="font-size: 18px; color: #000000;">{{article.newsTitle}}</div>
            <div style="font-size: 14px; color: #999999;"><span>{{article.readNum + ' 阅读'}}</span><span
                    style="margin-left: 10px; color: #333333;">{{article.source}}</span>
            </div>
            <div v-html="article.newsContent" class="articleContent"/>
            <div style="display: flex; justify-content: space-between; font-size: 12px; color: #999999;">
                <div>{{`本文章来源: ${article.source}`}}</div>
                <div>{{article.newsDate}}</div>
            </div>
        </div>
        <div style="border-top: 10px #F3F3F3 solid; margin: 5px 0 54px 0; padding: 10px 20px;">
            <div style="font-size: 14px; font-weight: bold; margin-bottom: 15px;">评论<span
                    style="margin-left: 10px; font-size: 12px; font-weight: normal;">{{`共${total}条评论`}}</span></div>
            <van-list v-model="loading" :finished="finished" :finished-text=finishText @load="loadComments">
                <div v-for="(item,index) in showComments" :key="index" style="display: flex; margin-top: 10px;">
                    <van-image round width="30" height="30" :src="item.imageUrl"/>
                    <div :style="`display: flex; flex-direction: column; flex: 1; margin: 0 0 5px 15px; padding-bottom: 15px; border-bottom: ${index == showComments.length-1 ? 0 : 1}px #F5F5F5 solid;`">
                        <div style="font-size: 14px; font-weight: bold;">{{item.userName}}</div>
                        <div :style="`word-wrap: break-word; width: ${windowWidth - 85}px; color: #666666; font-size: 14px; margin: 8px 0;`">
                            {{item.contents}}
                        </div>
                        <div style="font-size: 11px; color: #656A7B; display: flex; justify-content: space-between; align-items: center;">
                            <div>{{item.createTime|dateFormat('MM-DD HH:mm')}}</div>
                            <div style="display: flex; align-items: center;" @click="like(item.id)">
                                <van-icon name="good-job-o" style="margin-right: 5px;"/>
                                <span>{{item.likeNum}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
            <div v-if="!fshowMore"
                 style="color: #999999; background-color: #EFEFEF; padding: 10px 0; text-align: center; width: 100%; border-radius: 3px; font-size: 14px;"
                 @click="showMore = true"
            >查看全部评论
            </div>
        </div>
        <div style="background-color: white; position: fixed; bottom: 0; height: 44px; width: 100%; display: flex;">
            <div @click="collection"
                 style="width: 100px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <van-icon name="star" :color="collectionButtonColor"/>
                <span :style="'color:'+ collectionButtonColor + '; font-size: 12px;'">{{status ==='1' ? '取消收藏' : '收藏'}}</span>
            </div>
            <van-button icon="records" type="default" style="flex: 1; color: #066BEF; border-width: 0 0 0 1px"
                        @click="showPop = true">写评论
            </van-button>
        </div>

        <van-popup v-model="showPop" position="bottom" style="right: 0;">
            <div style="display: flex; flex-direction: column; align-items: center; background-color: white; padding: 10px;">
                <van-field v-model="commentContent" :border="false" type="textarea"
                           :autosize="{ maxHeight: 260, minHeight: 100 }" placeholder="请在此处输入您的留言"
                           style="margin: 10px; border: 1px #F5F5F5 dashed"/>
                <van-button type="info" style="padding: 0 30px; margin-bottom: 10px;" @click="addComment">留言
                </van-button>
            </div>
        </van-popup>

    </div>
</template>

<script>

    import Vue from 'vue';
    import {Button, Icon, Image, List, Field, Popup, Notify, Toast} from 'vant';
    import {wxChatShare} from '@/utils/wxShare'
    import Cookies from 'js-cookie'
    import Store from '@/utils/store'

    Vue.use(Button).use(Icon).use(Image).use(List).use(Field).use(Popup).use(Notify).use(Toast);

    export default {
        name: "productDetail",
        data() {
            return {
                windowWidth: window.outerWidth,
                newsId: this.$route.query.newsId || '',
                user: this.$store.state.user.user,
                article: {},
                comments: [],
                page: 0,
                pageSize: 10,
                total: '',
                loading: false,
                finished: false,
                showMore: false,
                commentContent: '',
                showPop: false,
                firstShowCount: 8,
                status: '',
                type: Cookies.get('type'),
            }
        },
        created() {
            this.loadArticleInfo();
            Store.$on('shareClick', (path) => {
                if (path === '/articleDetail') {
                    this.$axios.post("/love/share", {productId: this.newsId, type: this.article.newsStatus})
                }
            })
        },
        mounted(){
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.goBack, false);
        },
        computed: {
            showComments: function () {
                return this.showMore ? this.comments : this.comments.slice(0, this.firstShowCount);
            },
            finishText: function () {
                return this.showMore ? "没有更多了" : "";
            },
            collectionButtonColor: function () {
                return this.status === '1' ? '#066BEE' : '#999999'
            }
        },
        methods: {
            goBack(){
                this.$router.replace({path: '/'});
                //replace替换原路由，作用是避免回退死循环
            },
            loadArticleInfo() {
                this.$axios.get("/article/info", {params: {newsId: this.newsId}}).then(res => {
                    this.article = res.data.notice;
                    this.status = res.data.status;
                    this.settingShare();
                })
            },
            settingShare() {
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: this.article.newsTitle, // 分享数据配置 主标题
                    desc: this.article.abstracts || this.article.newsTitle, // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '/articleDetail?newsId=' + this.newsId + '&shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                    imgUrl: this.article.newsImage, // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                wxChatShare(param);
            },
            loadComments() {
                this.page++;
                this.loading = true;
                let params = {newsId: this.newsId, page: this.page, pageSize: this.pageSize}
                this.$axios.get("/comment/list", {params: params}).then(res => {
                    this.total = res.data.total;
                    this.showMore = (this.total <= this.firstShowCount) && this.showMore == false
                    this.loading = false;
                    let comments = res.data.rows;
                    this.comments = this.comments.concat(comments);
                    if (comments.length < this.pageSize) {
                        this.finished = true;
                    }
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                    this.error = true;
                })
            },
            like(id) {
                this.$axios.get("/comment/like", {params: {id: id}}).then(res => {
                    this.comments.forEach(item => {
                        if (id === item.id) {
                            item.likeNum = res.data;
                        }
                    })
                })
            },
            addComment() {
                if (this.commentContent.length == 0 || this.commentContent.replace(/\s+/g, "") == "") {
                    Notify({
                        message: '请填写评论内容！',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.commentContent.length > 100) {
                    Notify({
                        message: '评论内容最多输入100个字符！',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                this.$axios.post("/comment/add", {articleId: this.newsId, contents: this.commentContent}).then(res => {
                    this.showPop = false;
                    this.comments = [res.data].concat(this.comments);
                    this.commentContent = '';
                })
            },
            collection() {
                this.$axios.get("/article/collection", {
                    params: {
                        newsId: this.newsId,
                        type: this.status === '1' ? '0' : '1'
                    }
                }).then(res => {
                    this.status = (this.status === '1') ? '0' : '1';
                })
            }
        }
    }

</script>

<style scoped>
    .articleContent {
        font-size: 14px;
    }

    .articleContent img {
        padding: 5px;
        box-sizing: border-box;
        width: 100%;
    }

</style>
